
import { defineComponent } from 'vue';
import { useControlCenterStore } from '../store';
import LoadPackagesPopup from '../components/LoadPackagesPopup.vue';
import SearchableDropDown from '@/modules/globalModule/components/SearchableDropDown.vue';
import { IdleConnectionStrategy } from '../components/robotConnection/robotConnection';
export default defineComponent({
  name: 'ConnectToRobot',
  components: {
    LoadPackagesPopup,
    SearchableDropDown
  },
  data(): {
    hostname: string;
    port: number;
    username: string;
    password: string;
    sourcePath: string;
    connectionStatus: string;
    domainId: number;
    isLoadingPackages: boolean;
    selectedLoadMode: number;
    loadPackagesModes: Array<{ id: number; name: string }>;
  } {
    return {
      hostname: '',
      port: 22,
      username: '',
      password: '',
      sourcePath: '',
      connectionStatus: 'disconnected',
      domainId: 30,
      isLoadingPackages: false,
      selectedLoadMode: 0,
      loadPackagesModes: [
        {
          id: 0,
          name: 'Do not load any packages'
        },
        {
          id: 1,
          name: 'Load all packages from robot'
        },
        {
          id: 2,
          name: 'Only load packages not already loaded in the current workspace'
        },
        {
          id: 3,
          name: 'Load all packages but skip loading launch files'
        },
        {
          id: 4,
          name: 'Skip launch files and only load packages not already loaded in the current workspace'
        }
      ]
    };
  },
  mounted() {
    const store = useControlCenterStore();
    store.workspaceId = this.$route.params.workspaceId as string;
    store.loadConnections();
    console.log(store.previousConnections);
    if (store.previousConnections.length > 0) {
      const mostRecentConnection = store.previousConnections[0];
      this.hostname = mostRecentConnection.hostname;
      this.port = mostRecentConnection.port;
      this.username = mostRecentConnection.username;
      this.sourcePath = mostRecentConnection.sourcePath;
    } else {
      this.hostname = '';
      this.port = 22;
      this.username = '';
      this.password = '';
      this.sourcePath = '';
    }
  },
  methods: {
    onExit() {
      const store = useControlCenterStore();
      store.disconnect();
      this.$router.back();
    },
    onConnect(): void {
      try {
        const store = useControlCenterStore();
        store.storeConnection(
          this.hostname,
          this.username,
          this.port,
          this.domainId,
          this.sourcePath,
          this.password,
          this.setStatus
        );
      } catch (e: unknown) {
        console.log(`error when attempted to connect: ${e}`);
      }
    },
    isConnected(): boolean {
      return this.connectionStatus === 'connected';
    },
    // Set status function to be called by the websocket connection
    setStatus(status: string) {
      // if the connections status is just being set to connected
      if (status === 'connected' && this.connectionStatus !== 'connected') {
        if (this.selectedLoadMode === 0) {
          this.$router.push(`/controlCenter/${this.$route.params.workspaceId}`);
          useControlCenterStore().currConnection?.setStrategy(
            new IdleConnectionStrategy()
          );
        } else this.isLoadingPackages = true;
      }
      this.connectionStatus = status;
    },
    setPackageLoadingVisibility(
      visible: boolean,
      completed: boolean = false
    ): void {
      this.isLoadingPackages = visible;
      if (completed)
        this.$router.push(`/controlCenter/${this.$route.params.workspaceId}`);
    }
  }
});
